import { Component, Input, OnInit } from '@angular/core';
import { OmnialContent } from 'src/@omnial/_models/omnial.content.model';

@Component({
    selector: 'app-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.scss'],
    standalone: false
})
export class WidgetComponent implements OnInit {
  @Input() content: string;

  public rendered = false;
  public contentChunks: OmnialContent[] = [];
  public parser = new DOMParser();

  constructor() { }

  ngOnInit(): void {
    if (!this.content) {
      return;
    }
    let contentChunks = [];
    const htmlChunk = new OmnialContent();
    htmlChunk.index = 0;
    htmlChunk.type = 'html';
    htmlChunk.html = '';
    this.content = this.content.replaceAll('<div class="omnial-widget-holder omnial-widget-holder-start mceNonEditable">WIDGET START</div>','<div class="omnial-widget-holder">WIDGET</div>');
    this.content = this.content.replaceAll('<div class="omnial-widget-holder omnial-widget-holder-end mceNonEditable">WIDGET END</div>','<div class="omnial-widget-holder">WIDGET</div>');
    const chunks = this.content.split('<div class="omnial-widget-holder">WIDGET</div>');
    let chunkIndex = 0;
    chunks.forEach((chunk) => {
      if (chunk && chunk !== null) {
        const newChunk = new OmnialContent();
        try {
          var contentElement = this.parser.parseFromString(chunk, 'text/html').body.firstElementChild;
          // We have chunked it up now see if there is an Omnial Widget in this chunk
          if (contentElement.nodeName.toLowerCase() === 'div' && contentElement.className.toLowerCase().startsWith('omnial-widget')) {
            newChunk.index = chunkIndex;
            newChunk.html = '';
            newChunk.entityId = parseInt(contentElement.getAttribute('data-entity-id'));
            newChunk.type = contentElement.getAttribute('data-entity-type');
            contentChunks.push(newChunk);
          } else {
            htmlChunk.html += `<div id="placement-chunk-${chunkIndex}"></div>` + chunk;
            chunkIndex++;
          }
        }
        catch (e) {
          htmlChunk.html += `<div id="placement-chunk-${chunkIndex}"></div>` + chunk;
          chunkIndex++;
        }
      }
    });
    contentChunks.push(htmlChunk);
    this.contentChunks.push(htmlChunk);
    contentChunks.forEach((chunk) => {
      if (chunk.type !== 'html') {
        this.contentChunks.push(chunk);
      }
    });
    setTimeout(() => {
      this.moveWidgets();
    }, 200);
  }

  moveWidgets(): void {
    // Get the DOM nodes for the widgets and move them around
    for (var i = 0; i < this.contentChunks.length; i++) {
      const widget = document.getElementById(`widget-chunk-${i}`) as HTMLElement;
      const widgetPlacement = document.getElementById(`placement-chunk-${i}`) as HTMLElement;
      if (widget && widgetPlacement) {
        widgetPlacement.after(widget);
      }
    }
    setTimeout(() => {
      this.rendered = true;
    }, 200);
  }
}
